export enum otpType {
    register = 1,
    forgotPassword = 2
  }